import { inmunetApi } from '../../../../../../api';

export const deleteUsuario = async() => {

    try {

        const { data } = await inmunetApi.delete(`/usuario`);

        if (!data.status) throw (data.msg) ? data.msg : 'Error al cancelar cuenta';

        return data;

    } catch (error) {

        throw new Error(error);

    }

};